import React from 'react';
import DragPopup from './drag-popup/DragPopup';
import Header from './header';
import SideBar from './sidebar';
import { SaveLayoutPopup, NotifySaveLayoutPopup } from './sidebar/save-layout';

export default function(props) {
  return (
    <div className="container-fluid">
      <SaveLayoutPopup />
      <NotifySaveLayoutPopup />
      <header className="fiintrade-header pt-3">
        <Header />
      </header>
      <div className="fiintrade-leftsidebar">
        <SideBar {...props} />
      </div>
      <div role="main" className="fiintrade-main">
        {props.children}
        <DragPopup />
      </div>
    </div>
  );
}
